import { domReady } from '../modules/utils.js';

class CareerJobs extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();

    const form = document.querySelector('.career-form');

    this.refs = {
      items: [...this.querySelectorAll('.career-job')],
      form,
      select: form?.querySelector('select'),
    };
    this.#setListeners();
  }

  disconnectedCallback() {
    this.#unsetListeners();
  }

  #setListeners() {
    this.addEventListener('click', this.#onClick);
  }

  #unsetListeners() {
    this.removeEventListener('click', this.#onClick);
  }

  #onClick = (event) => {
    const toggle = event.target.closest('.career-job-toggle');
    if (!toggle) return;

    const item = toggle.closest('.career-job');
    if (!item) return;

    this.#populateForm(item);

    const isOpen = item.hasAttribute('data-open');
    const previouslyOpen = this.refs.items.find((el) => el !== item && el.hasAttribute('data-open'));

    for (const el of this.refs.items) {
      el.removeAttribute('data-open');
    }

    if (isOpen) return;

    item.setAttribute('data-open', '');

    const collapsingPanel = previouslyOpen?.querySelector('.career-job-panel');
    const collapsingAbove = collapsingPanel
      && (item.compareDocumentPosition(previouslyOpen) & Node.DOCUMENT_POSITION_PRECEDING);

    if (!collapsingAbove) {
      this.#scrollToItem(item);
      return;
    }

    const onTransitionEnd = (transitionEvent) => {
      if (transitionEvent.target !== collapsingPanel || transitionEvent.propertyName !== 'grid-template-rows') return;
      collapsingPanel.removeEventListener('transitionend', onTransitionEnd);
      this.#scrollToItem(item);
    };
    collapsingPanel.addEventListener('transitionend', onTransitionEnd);
  };

  #populateForm(item) {
    if (!this.refs.form) return;

    const jobTitle = item.querySelector('.career-job-title')?.textContent;

    // if (this.refs.select) {
    //   let option = this.refs.select.querySelector(`option[value="${jobTitle}"]`);
    //   if (!option) {
    //     option = document.createElement('option');
    //     option.value = jobTitle;
    //     option.textContent = jobTitle;
    //     this.refs.select.appendChild(option);
    //   }
    // }

    if (this.refs.select && jobTitle) {
      this.refs.select.value = jobTitle;
    }

    this.refs.form.scrollIntoView({ behavior: 'smooth' });

    const firstInput = this.refs.form.querySelector('input, textarea, select');
    firstInput?.focus();
  }

  #scrollToItem(item) {
    const top = item.getBoundingClientRect().top + window.scrollY - this.#getTopbarHeight();

    window.scrollTo({ top, behavior: 'smooth' });
  }

  #getTopbarHeight() {
    const probe = document.createElement('div');
    probe.style.cssText = 'position: absolute; visibility: hidden; height: var(--topbar-height);';
    document.body.appendChild(probe);
    const height = parseFloat(getComputedStyle(probe).height) || 0;
    probe.remove();

    return height;
  }
}

customElements.define('career-jobs', CareerJobs);
